const host = 'plum-village.azurewebsites.net';
export const USER_API_URL = `https://${host}/api/accounts`;
export const ROLE_API_URL = `https://${host}/api/roles`;
export const ROOM_API_URL = `https://${host}/api/rooms`;
export const ROOMTYPE_API_URL = `https://${host}/api/room-types`;
export const RETREAT_API_URL = `https://${host}/api/retreats`;
export const RETREAT_LESSON_API_URL = `https://${host}/api/retreats/lessons`;
export const RETREAT_MONK_API_URL = `https://${host}/api/retreats/monks`;
export const TOOL_API_URL = `https://${host}/api/tools`;
export const LESSON_API_URL = `https://${host}/api/lessons`;
export const TOOLHISTORY_API_URL = `https://${host}/api/tool-histories`;
export const PAYMENT_API_URL = `https://${host}/api/payments`
export const SCHEDULE_API_URL = `https://${host}/api/schedule`
export const DISH_API_URL = `https://${host}/api/dish`
export const MENU_API_URL = `https://${host}/api/menu`
export const DISHTYPE_API_URL = `https://${host}/api/dish-type`
export const RETREAT_REQ_API_URL = `https://${host}/api/retreat-registration`
export const FEEDBACK_API_URL = `https://${host}/api/feedback`
export const GROUP_API_URL = `https://${host}/api/retreat-groups`
export const GROUP_SCHEDULE_API_URL = `https://${host}/api/group/schedule`